export const EVENTS = {
  ADMINS: {
    LIST_ALL: {
      REFRESH: 'admins.list_all.refresh',
      REFRESHING: 'admins.list_all.refreshing',
      REFRESH_ERROR: 'admins.list_all.refresh_error',
      REFRESHED: 'admins.list_all.refreshed'
    },
    CREATE_OR_UPDATE: {
      SHOW: 'admins.create_or_update.show',
      CREATING: 'admins.creating',
      CREATED: 'admins.created',
      CREATE_ERROR: 'admins.create_error',
      UPDATING: 'admins.updating',
      UPDATED: 'admins.updated',
      UPDATE_ERROR: 'admins.update_error'
    },
    DELETE: {
      DELETING: 'admins.deleting',
      DELETED: 'admins.deleted',
      DELETE_ERROR: 'admins.delete_error'
    }
  }
};

export const ENDPOINTS = {
  ADMINS: {
    GET_LIST: '/user/{lacasaeBettingServiceName}-admin/all?group=lacasae',
    REGISTER: '/user/{lacasaeBettingServiceName}-admin/register?group=lacasae',
    UPDATE: '/user/{lacasaeBettingServiceName}-admin/update?group=lacasae',
    DELETE: '/user/{lacasaeBettingServiceName}-admin/delete?group=lacasae'
  }
};

export const AVAILABLE_FEATURES = {
  deposit: 'Recharge',
  collect: 'Collecte',
  usdtWithdraw: 'Recharge USDT',
  usdtCollect: 'Collecte USDT',
  withdrawBookmaker: 'Retrait Bookmaker',
  fundBookmaker: 'Recharge Bookmaker'
};

export const AVAILABLE_COUNTRIES = {
  BJ: 'Bénin',
  BF: 'Burkina Faso',
  CI: "Côte d'Ivoire",
  GA: 'Gabon',
  SN: 'Sénégal',
  TG: 'Togo',
  ML: 'Mali',
  NE: 'Niger'
};

export const ADMIN = {
  EVENTS,
  ENDPOINTS,
  AVAILABLE_FEATURES,
  AVAILABLE_COUNTRIES
};
